import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Response_Test } from '../../../../../constants/APIs';

export default class ResponseTest extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator
              getUrl={gAPI_Response_Test}
              pageId="response-test"
            />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
